import React, { Component } from 'react';
import ReactExport from 'react-data-export';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class UnfreezeRequestExcel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            unfreezeRequestData: null,
            nullData: [{ columns: [], data: [] }],
        };
    }

    componentDidMount() {
        if (this.props.updateData === true) {
            this.populateUnfreezeRequestData();
        }
    }

    componentDidUpdate = async() => {
        if (this.props.updateData === true) {
            this.props.dataUpdated();
            await this.populateUnfreezeRequestData();
            document.getElementById("unfreezeReqReport").click();
        }
    }

    populateUnfreezeRequestData = async() => {
        let unfreezeRequestData = [];
        const borderStyle = {
            border: {
                top: { style: "thin", color: "000000" },
                right: { style: "thin", color: "000000" },
                bottom: { style: "thin", color: "000000" },
                left: { style: "thin", color: "000000" }
            }
        };

        if (this.props.unfreezeRequestData && this.props.unfreezeRequestData.length > 0) { 
            for (const record of this.props.unfreezeRequestData) {
                const resourceName = record.EntryUserId ? record.EntryUser.displayName : record.ApproverUserId ? record.ApproverUser.displayName : '';
                unfreezeRequestData.push([
                    {
                        value: resourceName,
                        style: borderStyle
                    },
                    {
                        value: record.StartDate ? moment(record.StartDate).format('MM-DD-YYYY') : '',
                        style: borderStyle
                    },
                    {
                        value: record.EndDate ? moment(record.EndDate).format('MM-DD-YYYY') : '',
                        style: borderStyle
                    },
                    {
                        value: record.Comment ? record.Comment : '',
                        style: borderStyle
                    },
                    {
                        value: record.Status ? record.Status : '',
                        style: borderStyle
                    },
                    {
                        value: record.createdAt ? moment(record.createdAt).format('MM-DD-YYYY HH:mm') : '',
                        style: borderStyle
                    }
                ])
            }

            let headerColumns = [
                { value: 'Name',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Start Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'End Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Comment',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Approval Status',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Requested Date',  style: {font: { bold: true }, border: borderStyle.border}},
            ];

            let emptyRow = [];
            for (const row of headerColumns) {
                if (row.value === 'Name' || row.value === 'Comment') {
                    let record = { title: '', width: { wpx: 250 } }
                    emptyRow.push(record);   
                } else {
                    let record = { title: '', width: { wpx: 150 } }
                    emptyRow.push(record);   
                }
                 
            }

            const unfreezeRequestGrid = [
                {
                    columns: [
                        {title: `Requested Date Range - ${moment(this.props.startDate).format('MM-DD-YYYY')} to ${moment(this.props.endDate).format('MM-DD-YYYY')}`, width: {wpx: 250}},
                        {title: '', width: {wpx: 150}},
                    ],
                    data: []
                },
                {
                    columns: emptyRow,
                    data: [headerColumns, ...unfreezeRequestData]
                }
            ];
    
            await this.setState({
                unfreezeRequestGrid: unfreezeRequestGrid
            });
        }

    }

    render() {
        return (
            <ExcelFile
                filename={'Unfreeze Requests - ' + moment(new Date()).format('DD-MMM-YYYY')}
                element={ 
                    <Button id={"unfreezeReqReport"} className="d-none">
                        {''}
                    </Button>
                }
            >
                <ExcelSheet
                    dataSet={this.state.unfreezeRequestGrid ? this.state.unfreezeRequestGrid : this.state.nullData}
                    name="Unfreeze Requests"
                />
            </ExcelFile>
        );
    }
}

export default UnfreezeRequestExcel;
